.root {
  font-size: 14.5px;
  line-height: 1.65;
  color: var(--color-text);
}

.h1,
.h2,
.h3 {
  font-weight: 700;
  color: var(--color-brand-primary);
  margin-top: 18px;
  margin-bottom: 8px;
}

.h1 {
  font-size: 18px;
}

.h2 {
  font-size: 16px;
}

.h3 {
  font-size: 14.5px;
}

.root > :first-child {
  margin-top: 0;
}

.sectionHeading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--color-brand-primary);
  background: var(--color-brand-primary-soft);
  border-left: 3px solid var(--color-brand-secondary);
  padding: 5px 10px;
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}

.paragraph {
  margin: 8px 0;
}

.list {
  margin: 8px 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.listItem {
  padding-left: 2px;
}

.link {
  color: var(--color-text-link);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.inlineCode {
  font-family: var(--font-mono);
  font-size: 0.92em;
  background: var(--color-surface-sunken);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 1px 5px;
}

.pre {
  margin: 10px 0;
  border-radius: var(--radius-md);
  background: var(--color-brand-primary-strong);
  overflow-x: auto;
}

.codeBlock {
  display: block;
  font-family: var(--font-mono);
  font-size: 13px;
  line-height: 1.55;
  color: #e7edf5;
  padding: 12px 14px;
}

.blockquote {
  margin: 10px 0;
  padding: 8px 14px;
  border-left: 3px solid var(--color-border-strong);
  color: var(--color-text-secondary);
  background: var(--color-surface-sunken);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
}

.tableWrap {
  overflow-x: auto;
  margin: 10px 0;
}

.table {
  border-collapse: collapse;
  width: 100%;
  font-size: 13.5px;
}

.table th,
.table td {
  border: 1px solid var(--color-border);
  padding: 6px 10px;
  text-align: left;
}

.table th {
  background: var(--color-surface-sunken);
  font-weight: 600;
}

.strong {
  color: var(--color-text);
  font-weight: 700;
}

.hr {
  border: none;
  border-top: 1px solid var(--color-border);
  margin: 14px 0;
}
